import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {
  PyramidCategory,
  PyramidLegendItem
} from 'src/app/components/categories-pyramid-display/categories-pyramid-display.component';

@Component({
  selector: 'app-pyramid',
  templateUrl: './pyramid.component.html',
  styleUrls: ['./pyramid.component.scss']
})
export class PyramidComponent implements OnInit {
  @Input() categories: PyramidCategory[] = [];
  @Input() legend: PyramidLegendItem[] = [];

  @Output() categorySelected = new EventEmitter<PyramidCategory>();

  constructor() { }

  ngOnInit(): void {
  }

  onCategorySelected(category: PyramidCategory) {
    this.categorySelected.emit(category);
  }

}
